<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
* { margin: 0; padding: 0; box-sizing: border-box; }
html { scroll-behavior: smooth; }
html, body { width: 100%; overflow-x: hidden; font-size: 14px; color: #303133; }
#app {
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Microsoft YaHei', Arial, sans-serif;
  width: 100%;
  overflow-x: hidden;
  min-height: 100vh;
  -webkit-font-smoothing: antialiased;
}
/* 全局卡片统一圆角与阴影 */
.el-card { border-radius: 8px; }
/* 全局按钮圆角 */
.el-button { border-radius: 4px; }
/* 主内容区背景 */
.main-content-bg { background: #f5f7fa; }
</style>
